import {
  useGetMilestoneAuditFilterDataMutation,
  useReactivateMilestonesMutation,
  useUpdateMilestoneActualDatesByMilestoneIdMutation,
  useUpdateMilestoneByMilestoneIdMutation,
  useUpdateMilestoneEndPlannedDatesMutation,
  useUpdateMilestoneStartPlannedDatesMutation
} from 'src/services/MilestoneTracking';

export const useAMilestoneDetailModal = () => {
  const [getauditFilterData, { isLoading: auditFilterLoading, data: auditFilterData, error: auditFilterError }] =
    useGetMilestoneAuditFilterDataMutation();

  const [updateMilestone, { data: updateMilestoneData, error: updateMilestoneError }] =
    useUpdateMilestoneByMilestoneIdMutation();

  const [
    updateMilestoneStartPlannedDates,
    {
      isSuccess: updateStartPlanneddateSuccess,
      data: updateStartPlannedDateData,
      isError: updateStartPlannedDateDataIsError
    }
  ] = useUpdateMilestoneStartPlannedDatesMutation();
  const [
    updateMilestoneEndPlannedDates,
    { isSuccess: updateEndPlanneddateSuccess, data: updateEndPlannedDateData, isError: updateEndPlannedDateDataIsError }
  ] = useUpdateMilestoneEndPlannedDatesMutation();

  const [updateActualDates, { data: updateActualDatesData }] = useUpdateMilestoneActualDatesByMilestoneIdMutation();

  const [
    reactivateMilestone,
    {
      isLoading: reactivateMilestoneLoading,
      data: reactivateMilestoneData,
      error: reactivateMilestoneError,
      isError: reactivateMilestoneDataIsError,
      isSuccess: reactivateMilestoneSucess
    }
  ] = useReactivateMilestonesMutation();

  return {
    auditFilterLoading,
    auditFilterData,
    auditFilterError,
    getauditFilterData,
    updateMilestone,
    updateMilestoneData,
    updateMilestoneError,
    updateStartPlannedDateData,
    updateEndPlannedDateData,
    updateMilestoneStartPlannedDates,
    updateMilestoneEndPlannedDates,
    updateStartPlanneddateSuccess,
    updateEndPlanneddateSuccess,
    updateStartPlannedDateDataIsError,
    updateEndPlannedDateDataIsError,
    reactivateMilestone,
    reactivateMilestoneData,
    reactivateMilestoneLoading,
    reactivateMilestoneError,
    reactivateMilestoneSucess,
    reactivateMilestoneDataIsError,
    updateActualDates,
    updateActualDatesData
  };
};
